import { createSlice } from "@reduxjs/toolkit";

const presertState = {
  presertdata: {},
};

const presertSlice = createSlice({
  name: "presert",
  initialState: presertState,
  reducers: {
    presertData: (state, actions) => actions.payload,
  },
});

export const { presertData } = presertSlice.actions;

export default presertSlice.reducer;
